import React from 'react';
import { Placeholder as BsPlaceholder, Stack, Form } from 'react-bootstrap';
import { Button } from 'lb-components';
import classNames from 'classnames';

import classes from './Header.module.scss';

const Placeholder = () => {
  return (
    <BsPlaceholder animation={'glow'} as={'div'}>
      <section
        className={classes.user}
      >
        <div className={classes.userAccount}>
          <div className={classes.status}>
            <BsPlaceholder style={{ width: '10rem' }} as={'span'} />
          </div>
          <div className={classes.pin}>
            <BsPlaceholder style={{ width: '8rem' }} as={'span'} />
          </div>
        </div>
        <div className={classes.safe} style={{ margin: 'unset' }}>
          <span className={classNames(classes.safeAmount, classes.hide)}>
            0.0
          </span>
          <BsPlaceholder
            as={Form.Check}
            type={'switch'}
            id={classes.safeSwitchId}
            className={classes.safeSwitch}
            disabled
          />
        </div>

        <BsPlaceholder.Button style={{ width: '9rem' }} variant={'success'} />
        <BsPlaceholder.Button style={{ width: '9rem' }} />
      </section>
    </BsPlaceholder>
  );
};

export default Placeholder;
